import { Navigate } from "react-router-dom";
import Contact from "./pages/Contact";
import Conception from "./pages/conception";
import Home from "./pages/home";
import Realisation from "./pages/realisation";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";

const AppRoutes = [
  {
    index: true,
    path: "/",
    key: 1,
    title: "Accueil",
    element: <Home />,
  },
  {
    key: 2,
    path: "/realisations",
    title: "Réalisations",
    element: <Realisation />,
  },
  {
    key: 3,
    path: "/conception",
    title: "Conception",
    element: <Conception />,
  },
  {
    key: 4,
    path: "/contact",
    title: "Contact",
    element: <Contact />,
  },
  {
    key: 5,
    path: "/mentions-legales",
    title: "Mentions légales",
    element: <MentionsLegales />,
  },
  {
    key: 6,
    path: "/politique-confidentialite",
    title: "Politique de confidentialité",
    element: <PolitiqueConfidentialite />,
  },
  // Anciennes adresses (avec le préfixe /maknirenov) redirigées vers les nouvelles
  { key: 7, path: "/maknirenov", element: <Navigate to="/" replace /> },
  { key: 8, path: "/maknirenov/", element: <Navigate to="/" replace /> },
  {
    key: 9,
    path: "/maknirenov/Realisation",
    element: <Navigate to="/realisations" replace />,
  },
  {
    key: 10,
    path: "/maknirenov/Conception",
    element: <Navigate to="/conception" replace />,
  },
  {
    key: 11,
    path: "/maknirenov/Contact",
    element: <Navigate to="/contact" replace />,
  },
  { key: 12, path: "*", element: <Navigate to="/" replace /> },
];

export default AppRoutes;
